<script setup lang="ts">
import { computed } from 'vue';
import { useDisplay } from 'vuetify';
import makeBlockie from 'ethereum-blockies-base64';
import { shortAddress, shortAddressName } from '@/helpers/shortAddress';
import BaseCopyBtn from '../atoms/BaseCopyBtn.vue';
import { getAddressSystem } from '@sonarwatch/portfolio-core';
import { copyToClipboard } from '@/helpers/copyToClipboard';
import BaseAddressSystemIcon from '../BaseAddressSystemIcon.vue';

const { smAndDown } = useDisplay();
const props = defineProps({
  address: { type: String, required: true },
  name: { type: String, required: false },
  showBlockie: { type: Boolean, default: false },
  showAddressSystem: { type: Boolean, default: false },
  blockieSize: { type: Number, default: 32 },
  addressSystemSize: { type: [Number, String], default: 16 },
  clickToCopy: { type: Boolean, default: false },
  showCopy: { type: Boolean, default: false },
  forceShort: { type: Boolean, default: false },
  ignoreName: { type: Boolean, default: false },
  noMono: { type: Boolean, default: false },
});

const text = computed(() => {
  if (props.name && !props.ignoreName)
    return props.forceShort || smAndDown.value
      ? shortAddressName(props.name)
      : props.name;
  return props.forceShort || smAndDown.value
    ? shortAddress(props.address)
    : props.address;
});
const addressSystem = getAddressSystem(props.address);

function onClickToCopy() {
  if (!props.clickToCopy) return;
  copyToClipboard(props.address);
}
</script>

<template>
  <div class="d-flex align-center" :class="{ 'font-family-mono': !noMono }">
    <v-avatar
      v-if="showBlockie"
      class="mr-4"
      rounded
      :size="blockieSize"
      :image="makeBlockie(address)"
    />
    <BaseAddressSystemIcon
      v-if="showAddressSystem && addressSystem"
      :size="addressSystemSize"
      :address-system="addressSystem"
      class="mr-4"
    ></BaseAddressSystemIcon>
    <span
      :title="address"
      @click="onClickToCopy"
      :style="{ cursor: clickToCopy ? 'pointer' : 'inherit' }"
    >
      {{ text }}
    </span>
    <base-copy-btn v-if="showCopy" class="ml-1" :text="address"></base-copy-btn>
  </div>
</template>
